import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { X, Flag, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MOTIFS = ["Harcèlement", "Arnaque / demande d'argent", "Faux profil", "Contenu inapproprié", "Autre"];

export const ReportModal = ({ autre, convId, userId, onClose }) => {
  const [motif, setMotif] = useState(MOTIFS[0]);
  const [commentaire, setCommentaire] = useState("");
  const [sending, setSending] = useState(false);

  const envoyer = async () => {
    setSending(true);
    try {
      await axios.post(`${API}/signalements`, {
        reporter_id: userId, cible_id: autre.id, motif, commentaire, conversation_id: convId || null,
      });
      toast.success("Signalement enregistré", { description: "Notre équipe va l'examiner. Merci de contribuer à la sécurité." });
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur lors du signalement");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" data-testid="report-modal">
      <div className="bg-white rounded-2xl w-full max-w-md p-6 space-y-5">
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-lg font-extrabold text-stone-900">Signaler {autre.firstname}</h3>
          <button onClick={onClose} data-testid="report-close" className="text-stone-400 hover:text-stone-700 transition-colors"><X size={18} /></button>
        </div>
        <div className="space-y-2">
          {MOTIFS.map((m) => (
            <label key={m} className={`flex items-center gap-3 px-4 py-3 rounded-xl border cursor-pointer text-sm transition-colors ${motif === m ? "border-[#E05638] bg-[#E05638]/5 font-semibold text-stone-900" : "border-[#E5DFD5] text-stone-600 hover:border-stone-400"}`}>
              <input type="radio" name="motif" checked={motif === m} onChange={() => setMotif(m)} className="accent-[#E05638]" data-testid={`report-motif-${MOTIFS.indexOf(m)}`} />
              {m}
            </label>
          ))}
        </div>
        <textarea
          value={commentaire}
          onChange={(e) => setCommentaire(e.target.value)}
          rows={3}
          maxLength={500}
          placeholder="Détails (optionnel)..."
          data-testid="report-comment"
          className="w-full bg-[#FAF8F5] border border-[#E5DFD5] rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#E05638]/50 resize-none"
        />
        <button
          onClick={envoyer}
          disabled={sending}
          data-testid="report-submit"
          className="w-full bg-[#E05638] hover:bg-[#C84428] disabled:opacity-50 text-white font-semibold py-3.5 rounded-full transition-colors inline-flex items-center justify-center gap-2"
        >
          {sending ? <Loader2 size={16} className="animate-spin" /> : <Flag size={15} />} Envoyer le signalement
        </button>
      </div>
    </div>
  );
};
